import { Logger } from '../../../../ui-toolkit/logging/LoggerService';
import { APIFactory } from '../../../../ui-toolkit/rest/APIFactory';
import { baseUrlService } from '../../../../ui-toolkit/rest/BaseUrlService';

export const doDeleteOrderLinkAction = async (id: string, orderLinkId: string): Promise<void> => {
  try {
    await APIFactory(baseUrlService.ApiLocation).delete(`orders/v5/admin/order_link/${orderLinkId}`);
  } catch (e: any) {
    Logger.error('Error: delete order link', e);
    return Promise.reject(e);
  }
};
